import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof6: FaireReviewEntity = {
  token: "review_sof6",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_zzwte273ph",
  reviewerName: "Rhonda",
  reviewerLocation: "Comfort, TX",
  stars: 5,
  reviewText: "I’ve purchased this brand at market and through Faire and have had great experiences with both. The fulfillment is fast and I can honestly say I’ve had no issues or even returns. My customers love the product and I’m one of those customers! I can hardly wait for my spring order!",
  reviewDate: "Feb 21, 2025",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
